module.exports = {
      id: "login-google-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#login-google",
      toString: function () {
        return this.url;
      }
    }